import React, {useEffect, useState, lazy, Suspense} from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { useJobs } from '../../Data/Jobs';
import { PageLoading } from '../../Components/Loading';
import SearchWrapper, {useSearch} from '../../Components/Search';
import Search from './Search';
import ScheduleJob from '../Customer/ScheduleJob';
import MarkAsDone from '../Customer/MarkAsDone';
import EditJob from '../Customer/EditJob';
import NoItems from '../../Components/EmptyStates/NoItems';
import Skip from '../Customer/Skip';
import Selectable, {useSelectable, SelectableToggle } from '../../Components/Selectable';
import MassActions from './MassActions';

const Job = lazy(() => import(/* webpackPreload: true, webpackChunkName: "ui-components" */'./Job'));

const Jobs = () => {

    return <>
        <Selectable>
            <TopBar title="Jobs" right={<SelectableToggle />} />
            <Page>
                <SearchWrapper persist="jobs-search">
                    <Inner  />
                </SearchWrapper>
            </Page>
        </Selectable>
    </>
}

const Inner = () => {
    const {searchDebounced, hasSearchConditions, liveSearch} = useSearch();
    const {jobs, isLoading, refresh, deleteJob} = useJobs(searchDebounced);
    const [scheduling, setScheduling] = useState(null);
    const [markingAsDone, setMarkingAsDone] = useState(null);
    const [skipping, setSkipping] = useState(null);
    const [editing, setEditing] = useState(null);
    const {replaceSelectable} = useSelectable();

    useEffect(() => {
        if (jobs) {
            replaceSelectable(jobs.map(job => `${job.customerId}-${job.id}`));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [jobs])

    return <>
        <Search isLoading={isLoading} refresh={refresh} />

        <MassActions refresh={refresh} className={'mt-4'} sticky />

        <ul className="divide-y divide-gray-200">
            <NoJobs jobs={jobs} isLoading={isLoading} hasSearchConditions={hasSearchConditions} />
            {jobs && jobs.filter(liveSearch).map(job => <Suspense fallback={null}>
                <Job key={job.id} {...{job, setScheduling, setMarkingAsDone, setSkipping, setEditing, deleteJob, refresh}} />
            </Suspense>)}
        </ul>

        <ScheduleJob job={scheduling} onClose={() => setScheduling(null)} then={refresh} />
        <MarkAsDone job={markingAsDone} onClose={() => setMarkingAsDone(null)} then={refresh} />
        <Skip job={skipping} onClose={() => setSkipping(null)} then={refresh} />
        <EditJob job={editing} onClose={() => setEditing(null)} then={refresh} />
    </>
}

const NoJobs = ({jobs, isLoading, hasSearchConditions}) => {
    if (!jobs) {
        return <PageLoading />
    }

    if (jobs.length > 0 || isLoading) {
        return null;
    }

    if (hasSearchConditions) {
        return <p className="text-center text-gray-500 text-sm mt-8">
            No jobs match your current search
        </p>
    } else {
        return <NoItems className="my-6" icon="Truck" title="No jobs" message="Add jobs to a customer using the Manage tab" disabled />
    }
}

export default Jobs;
